import { DefaultError, useQuery } from '@tanstack/react-query';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { IVideoLight } from './types';

export const useGetVideoLightList = () => {
  const { responseHandler } = useResponseHandler();
  return useQuery<IVideoLight[], DefaultError>({
    queryKey: ['video-light-list'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Video/LightList`,
      });

      return responseHandler(response, {
        groupName: `useGetVideoLightList`,
      });
    },
  });
};
